'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoEmbedCodeField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseAccessibilityTextField = require('@bibliocommons/base-accessibility-text-field');

var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcon = require('@bibliocommons/base-icon');

var _baseIcon2 = _interopRequireDefault(_baseIcon);

var _videoPreview = require('../../video-preview');

var _videoPreview2 = _interopRequireDefault(_videoPreview);

require('../styles/VideoEmbedCodeField.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoEmbedCodeField = exports.VideoEmbedCodeField = function (_BcReactComponent) {
  _inherits(VideoEmbedCodeField, _BcReactComponent);

  function VideoEmbedCodeField(props) {
    _classCallCheck(this, VideoEmbedCodeField);

    var _this = _possibleConstructorReturn(this, (VideoEmbedCodeField.__proto__ || Object.getPrototypeOf(VideoEmbedCodeField)).call(this, props));

    _this.bindAll('handleCancelPreview');
    _this.state = {
      focusInput: !!props.iFrameSrc
    };
    return _this;
  }

  _createClass(VideoEmbedCodeField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* For Testing purposes */}
  }, {
    key: 'handleCancelPreview',
    value: function handleCancelPreview(e) {
      e.preventDefault();
      this.setState({
        focusInput: true
      });
      this.props.handleCancelPreview();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          fieldErrors = _props.fieldErrors,
          submitting = _props.submitting,
          handleEmbedSnippetChange = _props.handleEmbedSnippetChange,
          iFrameSrc = _props.iFrameSrc,
          embedSnippet = _props.embedSnippet,
          handleFocus = _props.handleFocus,
          handleBlur = _props.handleBlur;


      var labelId = _lodash2.default.uniqueId('video_');
      var descriptionId = _lodash2.default.uniqueId('video_');

      if (iFrameSrc) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-video-embed-code-field' },
          _react2.default.createElement(
            'button',
            { className: 'btn btn-danger clear-preview', onClick: this.handleCancelPreview },
            _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash', screenReaderText: intl.formatMessage({ id: 'cancel_button' }) }),
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clear_preview' })
          ),
          _react2.default.createElement(_videoPreview2.default, { iFrameSrc: iFrameSrc, showActions: false })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-video-embed-code-field' },
        _react2.default.createElement(
          'span',
          { id: labelId, className: 'sr-only' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'enter_a_url_or_embed_code' })
        ),
        _react2.default.createElement(
          'span',
          { id: descriptionId, className: 'sr-only' },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'enter_a_url_or_embed_code_description' })
        ),
        _react2.default.createElement(_baseAccessibilityTextField2.default, {
          className: 'input-lg',
          id: 'video-text-field',
          fieldErrors: fieldErrors,
          errorKey: 'url',
          value: embedSnippet,
          focus: this.state.focusInput,
          placeholder: intl.formatMessage({ id: 'enter_a_url_or_embed_code' }),
          disabled: submitting,
          handleChange: handleEmbedSnippetChange,
          handlePaste: handleEmbedSnippetChange,
          handleFocus: handleFocus,
          handleBlur: handleBlur })
      );
    }
  }]);

  return VideoEmbedCodeField;
}(_baseBcReactComponent2.default);

VideoEmbedCodeField.propTypes = {
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  embedSnippet: _react.PropTypes.string,
  iFrameSrc: _react.PropTypes.string,
  submitting: _react.PropTypes.bool,
  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
  handleCancelPreview: _react.PropTypes.func.isRequired,
  handleBlur: _react.PropTypes.func.isRequired,
  handleFocus: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(VideoEmbedCodeField);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/video-embed-code-field/components/VideoEmbedCodeField.js
// module id = 1046
// module chunks = 4